import { useContext } from 'react';
import {
  AudioPlayerControlsContext,
  AudioPlayerStateContext,
  type AudioPlayerControls,
  type AudioPlayerState,
} from 'context/AudioPlayerContext';

export function useAudioPlayerState(): AudioPlayerState {
  const ctx = useContext(AudioPlayerStateContext);
  if (!ctx) throw new Error('useAudioPlayerState must be used within AudioPlayerProvider');
  return ctx;
}

export function useAudioPlayerControls(): AudioPlayerControls {
  const ctx = useContext(AudioPlayerControlsContext);
  if (!ctx) throw new Error('useAudioPlayerControls must be used within AudioPlayerProvider');
  return ctx;
}
